import { Service } from './http-service';
import type { PaginatedResponse } from '@/entities/pagination/paginated-response';
import type {
  Video,
  CreateVideoDto,
  UpdateVideoDto,
  VideosControllerFindAllData,
} from '@carvia/ros-client-types';

class VideosService extends Service<Video, CreateVideoDto, UpdateVideoDto> {
  constructor() {
    super('/videos');
  }

  async getAllWithQuery(params: VideosControllerFindAllData['query']) {
    const res = await this.httpClient.get<PaginatedResponse<Video>>(`${this.endpoint}`, {
      params,
    });
    return res.data;
  }
}

export const videosService = new VideosService();
